<template>
    <div v-if="congestion">
        <div class="row">
            <div class="col-md-12">
                <b-button variant="primary" class="float-right mb-1" v-if="congestion && loginState.isAdministrator" v-on:click="attest()"
                    :disabled="congestion.isAttested || sumTaxDecision != congestion.sum">
                    <b-spinner v-if="attesting" class="mr-1" type="border" small />
                    <i v-if="!attesting" class="cui-check icons font-lg mr-1"/> {{attesting ? "Attesterar" : "Attestera" }}</b-button>
                <b-button variant="primary" class="float-right mr-1 mb-1" 
                    v-if="congestion && loginState.isAdministrator" v-on:click="addPassage()"
                    :disabled="congestion.isAttested"><i class="fa fa-plus-square-o"></i> Lägg till rad</b-button>
            </div>
        </div>   
        <b-card>
            <div slot="header" v-if="congestion">{{congestion.passages[0].date | moment("YYYY-MM-DD")}} - {{congestion.passages.slice(-1)[0].date | moment("YYYY-MM-DD")}}
                <div class="card-header-actions">
                    <b-spinner v-if="loading" class="mr-1" type="border" small />
                </div>
            </div>

            <b-alert show variant="danger" v-if="congestion && sumTaxDecision != congestion.sum">
                <h4 class="alert-heading">Perioden är felaktig!</h4>
                Summan av passagerna ger <strong>{{sumTaxDecision | currency}}</strong> kr men fakturan anger <strong>{{congestion.sum | currency}}</strong> kr
            </b-alert>

            <table class="table table-striped" v-if="congestion">
                <thead>
                    <tr>
                        <th>Datum</th>
                        <th class="text-center">Antal passager</th>
                        <th class="text-center">Summa</th>
                        <th>Ort</th>
                        <th>Tjänstepassager</th>
                        <th class="text-center">Kommentar</th>
                        <th class="text-center">Skattebeslut</th>
                        <th class="text-center" v-if="loginState.isAdministrator">Radera</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="passage in $v.congestion.passages.$each.$iter" :key="passage.id.$model">
                        <td class="align-middle" v-if="passage.id.$model > 0">{{passage.date.$model | moment("YYYY-MM-DD")}}</td>
                        <td class="align-middle" v-else>
                            <b-form-input type="date" 
                                v-model="passage.date.$model"
                                :class="{ 'is-invalid':  passage.date.$anyError}"
                                :disabled="!loginState.isAdministrator"
                                style="width:200px"></b-form-input>
                        </td>
                        <td class="text-center align-middle" v-if="passage.id.$model > 0">{{passage.quantity.$model}}</td>
                        <td class="text-center align-middle" v-else>
                            <input type="number" class="form-control d-inline-flex" step="1" max="99" min="1" maxlength="2"
                                v-model.number="passage.quantity.$model"
                                style="width:70px;text-center"
                                :class="{ 'is-invalid':  passage.quantity.$anyError}">                            
                        </td>    
                        <td class="text-center align-middle" v-if="passage.id.$model > 0">{{passage.sum.$model}}</td>
                        <td class="text-center align-middle" v-else>
                            <input type="number" class="form-control d-inline-flex" step="1" max="999" min="1" maxlength="3"
                                v-model.number="passage.sum.$model"
                                style="width:70px;text-center"
                                :class="{ 'is-invalid':  passage.sum.$anyError}">                            
                        </td>   
                        <td class="align-middle" v-if="passage.id > 0">{{passage.city}}</td>
                        <td class="text-center align-middle" v-else>
                            <input class="form-control"
                                v-model="passage.city.$model"
                                style="width:150px;;margin:0 0 0 -10px"
                                :class="{'is-invalid': passage.city.$anyError}">                            
                        </td> 
                        <td v-if="congestion.isAttested || passage.id <= 0">{{passage.businessPassages.$model}}</td>
                        <td class="align-middle text-center justify-content-center" v-else>
                            <input class="form-control" type="number" step="1" min="0" :max="passage.quantity"
                                v-model.number="passage.businessPassages.$model"
                                style="width:100px"
                                :class="{'is-invalid': passage.businessPassages.$anyError}">
                        </td>
                        <td class="text-center align-middle" v-if="congestion.isAttested || passage.id <= 0">{{congestion.comment}}</td>    
                        <td class="text-center align-middle" v-else><i class="cui-comment-square icons font-lg" v-on:click="addComment(passage)" style="cursor:pointer"></i></td>
                        

                        <td class="text-center align-middle" v-if="passage.id > 0">{{taxDecision(passage) | currency}}</td>
                        <td class="text-center align-middle" v-else>
                            <input type="number" class="form-control d-inline-flex" step="1" max="999" min="1" maxlength="3"
                                v-model="passage.taxDecision.$model"
                                :class="{'is-invalid': passage.taxDecision.$anyError}"
                                style="width:80px;text-center">                             
                        </td>                                                     
                        <td v-if="loginState.isAdministrator" class="text-center align-middle"><i class="cui-trash icons font-lg" style="cursor:pointer" v-on:click="deletePassage(passage)"/></td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td colspan="7" class="text-right"><strong style="margin-right:38px;">Total förmån {{totalTax | currency}} kr</strong></td>
                    </tr>
                </tfoot>
            </table>
            <b-button variant="primary"  @click="save()" v-if="congestion && !congestion.isAttested" :disabled="saving || sumTaxDecision != congestion.sum">
                <b-spinner v-if="saving" class="mr-1" type="border" small />{{saving ? "Sparar" : "Spara" }}
            </b-button>

            <b-modal id="deleteConfirmModal" title="Attestera" @ok="attestConfirm">
                <p class="my-4">Är du säker på att du vill attestera trängselskatt för perioden <br>
                    {{congestion.passages[0].date | moment("YYYY-MM-DD")}} - {{congestion.passages.slice(-1)[0].date | moment("YYYY-MM-DD")}}?</p>
            </b-modal>

        </b-card>
    </div>
</template>

<script>
import { globalStore } from "../../shared/helpers";
import { required } from 'vuelidate/lib/validators'
import { congestionsService, expensesService } from "../../shared/services";
import { truncate } from 'fs';

export default {
    computed: {
        loginState : function() {
        return globalStore.loginState;
        },
        sumTaxDecision() {
            var value = this.congestion.passages.reduce((sum, item) => {
                return sum + parseInt(item.taxDecision);
            }, 0);

            return value;
        },
        totalTax() {
            var result = this.congestion.passages.reduce((sum, item) => {
                return sum + this.taxDecision(item);
            }, 0);

            return result;   
        }
    },
    data() {
        return {
            loading: false,
            saving: false,
            attesting: false,
            congestion: null
        }
    },
    validations: {
        congestion: {
            passages: {
                $each: {
                    id: {},
                    date: {
                        required
                    },
                    quantity: {
                        required
                    },
                    sum: {
                        required
                    },
                    city: {
                        required
                    },
                    businessPassages: {
                        required
                    },
                    taxDecision: {
                        required
                    }
                }
            }
        }
    },
    mounted() {
        this.loading = true;
        congestionsService.getById(this.$route.params.id).then(p => {
            this.congestion = p;
            this.loading = false;
        }).catch(() => {
            this.ShowToast("Fel", "Ett okänt fel uppstod då trängselskattepassagerna skulle hämtas", "danger")
            this.loading = false;
        });
    },
    methods: {
        taxDecision(passage) {
            var nonBusinessPassages = passage.quantity - passage.businessPassages;
            return nonBusinessPassages/passage.quantity*passage.taxDecision;
        },
        addPassage() {
            var id = this.congestion.passages.length;
            this.congestion.passages.unshift({
                id:-id,
                businessPassages: 0,
                city: "",
                comment: "",
                quantity:0,
                sum:0,
                taxDecision: 0,
            })
        },
        deletePassage(passage) {
            var index = this.congestion.passages.indexOf(passage);
            if (index > -1) {
                this.congestion.passages.splice(index, 1);
            }
        },
        attest() {
            this.$bvModal.show('deleteConfirmModal');
        },
        attestConfirm() {
            this.attesting = true;
            congestionsService.attest(this.congestion.id).then(p => {
                this.congestion = p;
                this.attesting = false;
                this.ShowToast("Attesterat", "Passager för trängselskatt attesterades", "success")
            }).catch(() => {
                        this.ShowToast("Fel", "Ett okänt fel uppstod då passagerna för trängselskatten skulle attesteras", "danger")
                        this.attesting = false;
                    });
        },
        save() {
            this.$v.congestion.$touch();
            if(this.$v.congestion.$anyError) return;


            this.saving = true;
            congestionsService.saveCongestion(this.congestion).then(p => {
                this.saving = false;
                this.ShowToast("Sparat", "Passager för trängselskatt sparades", "success")
                this.congestion = p;
            }).catch(() => {
                this.ShowToast("Fel", "Ett okänt fel uppstod då passagerna för trängselskatten skulle sparas", "danger")
                this.saving = false;
            });
        },

    }
}
</script>

<style>

</style>
